<div class="mt-4 min-h-screen flex justify-center items-center">
  <div class="placeholder flex flex-col items-center text-center">
    <img
      [src]="
        fields.uiOptions.image
          ? fields.uiOptions?.image
          : './assets/media/illustrations-image/illustration-2.png'
      "
      class="mb-4 h-150px"
    />
    <span [ngStyle]="fields.uiOptions?.style" class="text-md text-gray-600">{{
      fields.displayName
    }}</span>
    <span class="text-sm text-gray-500 w-500px">{{ fields.helpText }}</span>
  </div>
</div>
